import React from 'react';
import { jumpTo } from '@/navigate'
import { inject, observer } from "mobx-react";
import Swiper from "swiper"
import './index.scss';
@inject("ScoreStore")
@observer
class App extends React.Component {
    state = {}
    componentDidMount() {
        var mySwiper = new Swiper('.swiper-container', {
            speed: 400,
            slidesPerView: 4,
            setWrapperSize: true,
            spaceBetween: 34,
            navigation: {
                nextEl: '.list_next',
                prevEl: '.list_prev',
            },
        });
    }
    setClassInfo(index) {
        this.props.ScoreStore.setClass(index);
        // window.open('new')
        jumpTo("guide3")

        // window.location.href='/guide3';
        // self.location.href=
        // window.Location.
    }

    // setClassInfo2(index) {
    //     // this.props.ScoreStore.setClass(index);
    //     // jumpTo("guide3")
    //     window.location.href='http://210.41.222.190/fzsy/1141.jhtml';
        
    // }

    

    render() {
        return (
            <div className="page page-guide guide">
                <div className="logoBox">
                    <img src={require('../../assets/images/logo_1.png')} alt="" className="logoBox-img1" />
                    <span className="logoBox-split"></span>
                    <img src={require('../../assets/images/logo_2.png')} alt="" className="logoBox-img2" />
                    <span className="logobox-txt">针灸推拿学院/第三附属医院</span>
                </div>
                <div className="titleBox">
                    <div className="ms_txt">选择课程</div>
                </div>
                <div className="list-card">
                    <i className="list_prev"><img src={require("../../assets/images/icon_prev.png")} /></i>
                    <i className="list_next"><img src={require("../../assets/images/icon_next.png")} /></i>
                    <div className="swiper-container">
                        <div className="swiper-wrapper">

                         {/* 一期 */}
                        <div className="card_item swiper-slide active" onClick={() => { this.setClassInfo(0) }}>
                                <div className="card_tit">第一期</div>
                                <div className="card_bd">内容简介：通过仿真操作练习，能够根据病史诊断患者疾病，制定针灸治疗处方，并进行针灸操作。</div>
                                <div className="card_tips"><span>病人病症表现：</span>男，38岁，“反复腹泻3年，加重3天”就诊。</div>
                            </div>

                            {/* 二期 */}
                        <div className="card_item swiper-slide active" onClick={() => { window.open('http://210.41.222.190/fzsy/1071.jhtml' )}}>
                                <div className="card_tit">第二期 </div>
                                <div className="card_bd">内容简介：通过问诊，结合病史辩证疾病，并通过点穴、针刺进行治疗。</div>
                                <div className="card_tips"><span>病人病症表现：</span>男，34岁，“反复头痛10年，复发加重2天”就诊。</div>
                            </div>  
                            {/* 三期 */}
                            <div className="card_item swiper-slide active" onClick={() => { window.open('http://210.41.222.190/fzsy/1122.jhtml' )}}> 
                                <div className="card_tit">第三期</div>
                                <div className="card_bd">内容简介：通过问诊，结合病史辩证疾病，并通过点穴、针刺进行治疗。</div>
                                <div className="card_tips"><span>病人病症表现：</span>男，55岁，“颈项肩背不适5年，加重15天”就诊。</div>
                            </div>


                            <div className="card_item swiper-slide active">
                                <div className="card_tit">第四期</div>
                                <div className="card_dev">
                                    <img src={require('../../assets/images/dev_img.png')} />
                                    <span>开发中...</span>
                                </div>
                            </div>
                            <div className="card_item swiper-slide active">
                                <div className="card_tit">第五期</div>
                                <div className="card_dev">
                                    <img src={require('../../assets/images/dev_img.png')} />
                                    <span>开发中...</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div >
        );
    }
}

export default App;
